// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {FixedSpace} from '../core/Spacing';
// Controls
import Button from '../controls/Button';
import CheckBox from '../controls/CheckBox';
import ComboBox from '../controls/ComboBox';
import Radio from '../controls/Radio';
import SelectBox from '../controls/SelectBox';
import TabBar from '../controls/TabBar';
import TextField from '../controls/TextField';
// Layouts
import ToolBar from '../layouts/ToolBar';

export default class Components extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            componentsDemo: {
                display: "flex",
                flexDirection: "column-reverse",
            },
        });

        return (
            <div className={css(styles.componentsDemo)}>
                <ToolBar>
                    <TabBar items={["One", "Two", "Three"]} selectedIndex={0} />
                </ToolBar>
                <ToolBar>
                    <Radio label="Radio button" />
                    <FixedSpace />
                    <Radio label="Radio button" selected={true} />
                    <FixedSpace />
                    <CheckBox label="Check box" />
                    <FixedSpace />
                    <CheckBox label="Check box" selected={true} />
                </ToolBar>
                <ToolBar>
                    <TextField placeholder="Text field" />
                    <FixedSpace />
                    <SelectBox placeholder="Select box" options={["One", "Two", "Three"]} />
                    <FixedSpace />
                    <ComboBox placeholder="Combo box" />
                </ToolBar>
                <ToolBar>
                    <Button style={Button.Style.Link} title="Disclosure"/>
                    <FixedSpace />
                    <Button style={Button.Style.Link} variant={Button.Variant.Dropdown} />
                </ToolBar>
                <ToolBar>
                    <Button variant={Button.Variant.Dropdown} icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button style={Button.Style.Secondary} variant={Button.Variant.Dropdown} icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button style={Button.Style.Text} variant={Button.Variant.Dropdown} icon="assets/24x24-search.svg" />
                </ToolBar>
                <ToolBar>
                    <Button icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button style={Button.Style.Secondary} icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button style={Button.Style.Text} icon="assets/24x24-search.svg" />
                </ToolBar>
                <ToolBar>
                    <Button title="Primary" icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button title="Secondary" style={Button.Style.Secondary} icon="assets/24x24-search.svg" />
                    <FixedSpace />
                    <Button title="Text" style={Button.Style.Text} icon="assets/24x24-search.svg" />
                </ToolBar>
                <ToolBar>
                    <Button title="Primary" variant={Button.Variant.Dropdown} />
                    <FixedSpace />
                    <Button title="Secondary" style={Button.Style.Secondary} variant={Button.Variant.Dropdown}/>
                    <FixedSpace />
                    <Button title="Text" style={Button.Style.Text} variant={Button.Variant.Dropdown}/>
                </ToolBar>
                <ToolBar>
                    <Button title="Primary" />
                    <FixedSpace />
                    <Button title="Secondary" style={Button.Style.Secondary} />
                    <FixedSpace />
                    <Button title="Text" style={Button.Style.Text} />
                </ToolBar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/Components.jsx